import { useQuery } from "@tanstack/react-query";

import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import { getSelectedCategory } from "app/pages/industry-analysis/common/getSelectedCategory";
import type { ITopCountriesApiResponse } from "app/pages/industry-analysis/overview/components/TopCountriesChart/TopCountriesChart.types";
import type { CountryTrafficShare } from "app/pages/website-performance/components/TopCountries/type";
import { DefaultFetchService } from "app/services/fetchService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ROWS_TO_DISPLAY, ENDPOINT } from "../consts";

const fetchTopCountriesData = (): Promise<ITopCountriesApiResponse> => {
    const fetchService = DefaultFetchService.getInstance();
    const params = getQueryParams();
    const category = getSelectedCategory();
    const { forApi: keys, categoryHash } = category;
    const queryParams = { ...params, categoryHash, keys };
    return fetchService.get<ITopCountriesApiResponse>(ENDPOINT, queryParams);
};

const adaptTopCountriesData = (rawData: ITopCountriesApiResponse): CountryTrafficShare => {
    const data = rawData.Data.slice(0, ROWS_TO_DISPLAY);
    return data.map((dataItem) => {
        const { Country: country, TrafficShare: share, GrowthPercentage: change } = dataItem;
        return { country, share, change };
    });
};

export const useTopCountriesData = () => {
    const category = getSelectedCategory();
    const { duration, country, webSource, includeSubdomains } = proNavigator.getParams();

    const query = useQuery({
        queryKey: ["top-countries-single", category.id, duration, country, webSource, includeSubdomains],
        queryFn: fetchTopCountriesData,
        select: adaptTopCountriesData,
    });

    return {
        isLoading: query.isLoading,
        countriesTrafficShare: query.data || [],
    };
};
